import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const getPendingCashCut = async (sellerId, untilDate = null) => {
    const params = untilDate ? { until_date: untilDate } : {};
    const { data } = await axios.get(`${API}/cash-cuts/pending/${sellerId}`, { headers: authHeaders(), params });
    return data;
};

export const createCashCut = async ({ seller_id, cash_received, notes, until_date = null }) => {
    const payload = { seller_id, cash_received, notes };
    if (until_date) payload.until_date = until_date;
    const { data } = await axios.post(`${API}/cash-cuts`, payload, { headers: authHeaders() });
    return data;
};

export const listCashCuts = async ({ sellerId = null, startDate = null, endDate = null, withBreakdown = false } = {}) => {
    const params = {};
    if (sellerId) params.seller_id = sellerId;
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (withBreakdown) params.with_breakdown = true;
    const { data } = await axios.get(`${API}/cash-cuts`, { headers: authHeaders(), params });
    return data;
};

export const downloadCashCutPdf = async (cutId, folio) => {
    const res = await axios.get(`${API}/cash-cuts/${cutId}/pdf`, {
        headers: authHeaders(),
        responseType: 'blob',
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${folio || 'corte'}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
};

export const auditCashCut = async (cutId) => {
    const { data } = await axios.get(`${API}/cash-cuts/${cutId}/audit`, { headers: authHeaders() });
    return data;
};

export const downloadCashCutAuditExcel = async (cutId, folio) => {
    const res = await axios.get(`${API}/cash-cuts/${cutId}/audit/excel`, {
        headers: authHeaders(),
        responseType: 'blob',
    });
    const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `corte_${folio || cutId}_auditoria.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
};
